<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company showImage :data="companyData" :customData="details"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :details="details"/>
      </div>
      <div class="column">
        <Client :details="details"/>
      </div>
    </div>

    <Items class="block" :details="details" :items="details.Items"/>
    <Total class="block" :details="details" />
  </kst-page-print-details>
</template>

<script>
import Model from "../RinvModel.js";
import Services from "../../../services/Api/ReturnInvoiceServices.js";

import Client from "./RinvPD_Client.vue";
import Details from "./RinvPD_Details.vue";
import Items from "./RinvPD_Items.vue";
import Total from "./RinvPD_Total.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Client,
    Details,
    Items,
    Total,
    Company
  },
  data: () => ({
    companyData: {},
    details: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.details = data.Details;

      for (const item of this.details.Items) {
        Model.updateItem(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.details = {};
    }
  }
}
</script>